"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var PRODUCT_HISTORY_PAGE_LIMIT = 20;
var PURCHASED_PRODUCTS_ERROR = 'Error getting information about purchased products';
var SALES_REPRESENTATIVE_ERROR = 'Error getting information about your sales representative';
var PRODUCT_TRANSACTIONS_ERROR = 'Error getting information about transactions for this product';
var _require = require('underscore'),
  last = _require.last,
  first = _require.first;
var OrgEntitlements = /*#__PURE__*/function () {
  OrgEntitlements.$inject = ["$rootScope", "$scope", "$q", "entitlementsService", "userService"];
  /* @ngInject */
  function OrgEntitlements($rootScope, $scope, $q, entitlementsService, userService) {
    _classCallCheck(this, OrgEntitlements);
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.entitlementsService = entitlementsService;
    this.transactionViewPool = true;
    this.isUserSuperAdmin = userService.matchesRoles({
      globalRole: 'superadmin'
    });
  }

  /**
   * Initializes data and adds event listener for next and previous page loading
   *
   */
  _createClass(OrgEntitlements, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.loading = true;
      this.$q.all([this.getPurchaseOrganizationProducts().then(function (purchasedProducts) {
        return _this.purchasedProducts = purchasedProducts;
      }).catch(function (error) {
        console.error(error);
        _this.purchasedProductsError = PURCHASED_PRODUCTS_ERROR;
      }), this.entitlementsService.getOrganizationSalesRep(this.organisation._id).then(function (salesRepresentative) {
        return _this.salesRepresentative = salesRepresentative;
      }).catch(function (error) {
        console.error(error);
        _this.salesRepresentativeError = SALES_REPRESENTATIVE_ERROR;
      })]).finally(function () {
        return _this.loading = false;
      });
      this.$scope.$on('LOAD_PREVIOUS_TRANSACTION_PAGE', function (event, productName) {
        var _iterator = _createForOfIteratorHelper(_this.purchasedProducts),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var product = _step.value;
            if (product.name === productName) {
              var firstTransaction = first(product.transactionsPage.items);
              _this.getOrganizationProductTransactions(product, {
                startAt: firstTransaction._id
              }).catch(function /* error */
              () {
                return _this.$rootScope.setFlashMessage(PRODUCT_TRANSACTIONS_ERROR, 'danger');
              });
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
      this.$scope.$on('LOAD_NEXT_TRANSACTION_PAGE', function (event, productName) {
        var _iterator2 = _createForOfIteratorHelper(_this.purchasedProducts),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var product = _step2.value;
            if (product.name === productName) {
              var lastTransaction = last(product.transactionsPage.items);
              _this.getOrganizationProductTransactions(product, {
                endAt: lastTransaction._id
              }).catch(function /* error */
              () {
                return _this.$rootScope.setFlashMessage(PRODUCT_TRANSACTIONS_ERROR, 'danger');
              });
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      });
    }

    /**
     * Fetches the purchased products for the current organization
     *
     * @returns {Promise} - the purchased products by the organization
     */
  }, {
    key: "getPurchaseOrganizationProducts",
    value: function getPurchaseOrganizationProducts() {
      if (this.purchasedProducts) {
        return this.$q.resolve(this.purchasedProducts);
      }
      return this.entitlementsService.getPurchaseOrganizationProducts(this.organisation._id);
    }

    /**
     * Fetches the transactions history for a specific product for the current organization,
     * and assigns the transaction history to 'product.transactionsPage'. Supports pagination
     *
     * @param {number} productIndex - The index of the product in the this.purchasedProducts array
     * @param {object} page - The object specifying the pagination
     */
  }, {
    key: "getOrganizationProductTransactions",
    value: function getOrganizationProductTransactions(product) {
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        first: true
      };
      if (product.transactionsLoading) return;
      product.transactionsLoading = true;
      return this.entitlementsService.getOrganizationProductTransactions(this.organisation._id, product.productCodes, [this.entitlementsService.TYPE_ACCOUNT, this.entitlementsService.TYPE_TRANSACTION, this.entitlementsService.TYPE_EXPIRED], null, Object.assign(page, {
        limit: PRODUCT_HISTORY_PAGE_LIMIT
      })).then(function (transactionsPage) {
        product.transactionsPage = transactionsPage;
        product.transactionsLoading = false;
      }).finally(function () {
        return product.transactionsLoading = false;
      });
    }

    /**
     * Expands/collapses the product transactions table. Fetches product transactions if missing
     *
     * @param {Event} event - The click event
     * @param {object} clickedProduct - The product that was clicked
     */
  }, {
    key: "onProductClick",
    value: function onProductClick(event, clickedProduct) {
      var _this2 = this;
      if (event) event.preventDefault();
      if (!clickedProduct.transactionsPage) {
        this.getOrganizationProductTransactions(clickedProduct).catch(function () {
          return _this2.productTransactionsError = PRODUCT_TRANSACTIONS_ERROR;
        });
      }
      this.purchasedProducts = this.purchasedProducts.map(function (product) {
        return Object.assign(product, {
          expanded: clickedProduct.name === product.name ? !product.expanded : false
        });
      });
    }

    /**
     * SuperAdmin flush cache
     */
  }, {
    key: "flushCache",
    value: function flushCache() {
      var _this3 = this;
      if (this.flushing) {
        return;
      }
      this.flushing = true;
      return this.entitlementsService.flushCache().finally(function () {
        return _this3.flushing = false;
      });
    }

    /**
     * Toggle between view of all transactions and grouped view
     */
  }, {
    key: "toggleTransactionView",
    value: function toggleTransactionView() {
      this.transactionViewPool = !this.transactionViewPool;
    }
  }]);
  return OrgEntitlements;
}();
module.exports = angular.module('backstage.components.orgs.view-org.entitlements-manager.org-entitlements', ['backstage.services']).component('bsOrgEntitlements', {
  templateUrl: '/src/angular/components/orgs/view-org/org-entitlements-manager/org-entitlements/org-entitlements.html',
  bindings: {
    organisation: '<'
  },
  controllerAs: 'vm',
  controller: OrgEntitlements
}).name;